// The API restarting (a backend update takes a few seconds): requests fail
// with no answer or 502/503/504. The page shows a "reconnecting" banner,
// GET requests are retried, and the banner goes once the API answers again.

export const API_DOWN = "vb-api-down";
export const API_UP = "vb-api-up";

const RETRIES = 8; // ~30 s in all
const WAIT = (n) => Math.min(1500 * (n + 1), 5000);

let down = false;
const setDown = (v) => {
  if (down === v) return;
  down = v;
  window.dispatchEvent(new Event(v ? API_DOWN : API_UP));
};
export const apiIsDown = () => down;

// no answer, a gateway error, or nginx's "maintenance" while the API restarts
// (a feature's own 503 is not a restart)
const unreachable = (err) =>
  !!err?.config &&
  !axiosCancel(err) &&
  (!err.response ||
    [502, 504].includes(err.response.status) ||
    (err.response.status === 503 && err.response.data?.status === "maintenance"));
const axiosCancel = (err) => err?.code === "ERR_CANCELED" || err?.__CANCEL__;

/** Adds the banner + retries to an axios instance */
export const watchApi = (instance) => {
  instance.interceptors.response.use(
    (res) => {
      setDown(false);
      return res;
    },
    async (err) => {
      if (!unreachable(err)) {
        if (err?.response) setDown(false);
        throw err;
      }
      setDown(true);
      const cfg = err.config;
      // only reads are repeated: a POST could be done twice
      const method = String(cfg.method || "get").toLowerCase();
      cfg._apiTry = (cfg._apiTry || 0) + 1;
      if (method !== "get" || cfg._apiTry > RETRIES) throw err;
      await new Promise((r) => setTimeout(r, WAIT(cfg._apiTry)));
      return instance.request(cfg);
    }
  );
};
